// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PaperContainer-cls1__d45d5cbd20ffea8c848c{/*!*/}.PaperContainer-cls2__e1b62fc1e3d7ffebbeed{display:flex;align-items:stretch;grid-gap:8px;gap:8px}.PaperContainer-cls2__e1b62fc1e3d7ffebbeed>div>button{width:100%}@media(min-width: 768px){.PaperContainer-cls2__e1b62fc1e3d7ffebbeed{flex-direction:column}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "PaperContainer-cls1__d45d5cbd20ffea8c848c",
	"cls2": "PaperContainer-cls2__e1b62fc1e3d7ffebbeed PaperContainer-cls1__d45d5cbd20ffea8c848c"
};
export default ___CSS_LOADER_EXPORT___;
